import * as yup from "yup";

export const editUserSchema = yup.object().shape({
    role: yup.string().required("Field is required"),
    status: yup.string().required("Field is required"),
});
